import { render, staticRenderFns } from "./SpeciesSingle.vue?vue&type=template&id=6e3d4cb0"
import script from "./SpeciesSingle.vue?vue&type=script&lang=js"
export * from "./SpeciesSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports